import { render, staticRenderFns } from "./RefiereGana.vue?vue&type=template&id=03e8b144"
import script from "./RefiereGana.vue?vue&type=script&lang=js"
export * from "./RefiereGana.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports